import type { CalculationState } from '../../index';
import { createEvaluatedGridElementsSummary } from './createEvaluatedGridElementsSummary';
import { enrichGridElementSectionsWithEvaluatedResults } from './enrichGridElementSectionsWithEvaluatedResults';

export const gridElementsAttentionSummary = (
  state: CalculationState
): CalculationState['gridElementsAttentionSummary'] => {
  if (
    state.calculationTactic.current !== 'LOADED' ||
    state.calculationTactic.value.status !== 'Completed' ||
    state.gridElementsDetailsByCalculationType.type === 'NO_EVALUATION' ||
    state.gridElementsAttentionStatuses.type === 'NOT_AVAILABLE'
  )
    return { type: 'NO_GRID_ELEMENTS_SUMMARY' };

  return {
    type: 'GRID_ELEMENTS_SUMMARY_AVAILABLE',
    summary: enrichGridElementSectionsWithEvaluatedResults(
      createEvaluatedGridElementsSummary(
        state.calculationTactic.value.calculationSetResult.grid.containment,
        state.gridElementsDetailsByCalculationType.gridElementsDetails,
        state.gridElementsAttentionStatuses.byCalculationType
      ),
      state.gridElementsDetailsByCalculationType.gridElementsDetails
    )
  };
};
